import { useState } from 'react';
import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiRenderProps } from '../../../shared/ui/registry.js';
import { AirlineLogo } from '@voll-intelligence/intelligence-ui-kit';
import './question_prompt.css';

type Block = Extract<ChatUi, { kind: 'question_prompt' }>;

/**
 * Pergunta estruturada acima do composer (mock M6/image10): título + linhas de
 * opção (chip numerado, logo da cia quando houver, rota/label). `readOnly` não
 * renderiza — o prompt é efêmero, não histórico. Cada opção dispara a
 * `interaction` genérica com a decisão DETERMINÍSTICA no `data` (anti-LLM); o
 * `replyText` (sentença localizada do servidor) vira o balão do usuário.
 */
export function QuestionPrompt({ ui, readOnly, dispatch }: Readonly<GenUiRenderProps<Block>>) {
  // Trava local anti duplo-clique (a trava real — single-use — é server-side):
  // mesmo padrão do confirm_prompt.
  const [sent, setSent] = useState(false);
  if (readOnly) return null;
  const pick = (opt: Block['options'][number]) => {
    setSent(true);
    dispatch({
      type: 'interaction',
      interactionId: ui.challengeId,
      text: opt.replyText ?? opt.label,
      data: { action: 'select_option', optionId: opt.id },
      analytics: { actionId: 'select_option' },
    });
  };
  const titleId = `${ui.id}-q`;
  return (
    <div className="qp" role="group" aria-labelledby={titleId}>
      <p className="qp-question" id={titleId}>
        {ui.question}
      </p>
      <ol className="qp-options">
        {ui.options.map((opt, i) => (
          <li key={opt.id}>
            <button
              type="button"
              className="qp-option"
              disabled={sent}
              onClick={() => {
                pick(opt);
              }}
            >
              <span className="qp-num" aria-hidden>
                {i + 1}
              </span>
              {opt.airlineIata ? <AirlineLogo iata={opt.airlineIata} size={20} /> : null}
              <span className="qp-label">{opt.label}</span>
              {opt.sublabel ? <span className="qp-sublabel">{opt.sublabel}</span> : null}
            </button>
          </li>
        ))}
      </ol>
    </div>
  );
}
